import { gql } from '@apollo/client';

const ILT_CODES = gql`
    query completionCodes( $iltID: UUID! ) {
        completionCodes( iltID: $iltID ) {
            edges {
                node {
                    id
                    companyId
                    instructorLedTrainingId
                    code
                    sessionCompletionsCount
                    usedBySessionsCount
                    createdAt
                    deletedAt
                }
            }
        }
    }
`;

export default ILT_CODES;
